module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2n6r9n-94896165b19a34c4478ed45a3c5264e6.svg";